import gql from 'graphql-tag';

export default gql`
  mutation(
    $name: String!
    $libraryId: ID!
    $bookshopId: ID!
    $projectId: ID
    $bookshopMessage: String
  ) {
    addSuggestionsList(
      input: {
        libraryId: $libraryId
        bookshopId: $bookshopId
        projectId: $projectId
        name: $name
        bookshopMessage: $bookshopMessage
      }
    ) {
      id
    }
  }
`;
